import { StoreState } from "../RootReducer";

export const getDashboard14DayStats = (state: StoreState) =>
	state.Dashboard.fleetStats;

export const getDashboardRootJourneys = (state: StoreState) =>
	state.Dashboard.rootJourneys;

export const getDashboardRootReports = (state: StoreState) =>
	state.Dashboard.rootReports;

export const getDashboardComplianceReports = (state: StoreState) =>
	state.Dashboard.complianceReports;

export const getDashboardComplianceReport = (state: StoreState) =>
	state.Dashboard.complianceReport;

export const getDashboardGroupRankingReport = (state: StoreState) =>
	state.Dashboard.groupRankingReport;

export const getDashboardBrightCoachGroupRankingReport = (state: StoreState) =>
	state.Dashboard.brightCoachGroupRankingReport;

export const getDashboardUserRankingReport = (state: StoreState) =>
	state.Dashboard.userRankingReport;

export const getDashboardBrightCoachUserRankingReport = (state: StoreState) =>
	state.Dashboard.brightCoachUserRankingReport;

export const getDashboardGroupJourneys = (state: StoreState) =>
	state.Dashboard.groupJourneys;

export const getDashboardPillarSummaryTimeSelectionId = (state: StoreState) =>
	state.Dashboard.pillarSummaryTimeSelectionId;

export const getDashboardPillarBoxplots = (state: StoreState) =>
	state.Dashboard.pillarBoxplots;

export const getDashboardComparisonLevels = (state: StoreState) =>
	state.Dashboard.comparisonLevels;

export const selectCurrentScopeUserCount = (state: StoreState) =>
	state.Dashboard.userCount;
